/* hgn-kit-bar.js — moved verbatim from snippets/hgn-kit-bar.liquid on 2026-09-14 (page-weight phase B:
   inline JS → theme asset, loaded synchronously at the same position so execution order and
   DOMContentLoaded timing are unchanged). 1 original <script> block(s), in order.
   EDIT THIS FILE, not the snippet. */

(function () {
  'use strict';

  /* ─────────────────────────────────────────────────────────
     Kit-bar v2 — status banner + integrated switch + modals.
     The drawer / build flow now lives in hgn-side-cart.liquid;
     this script is the entry-point + the swap/off modals.
     ───────────────────────────────────────────────────────── */

  if (window.__hgnKitBarBooted) return;
  window.__hgnKitBarBooted = true;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else { fn(); }
  }

  ready(function () {
    var bar             = document.querySelector('[data-hgn-kit-bar]');
    if (!bar) return;
    /* CRITICAL: position:fixed gets rebased to any ancestor with
       `transform`, `filter`, `will-change: transform/opacity`, or
       `perspective` set. Many themes wrap sections in
       transform-bearing containers (e.g. for slide-in animations),
       which would silently break the bar's viewport pin and let
       the header scroll over it.
       Relocating the bar to be a direct child of <body> guarantees
       its containing block is the viewport, so `position: fixed`
       always anchors top:0 regardless of theme structure. */
    if (bar.parentNode !== document.body) {
      try { document.body.appendChild(bar); } catch (e) {}
    }
    var switchInput     = bar.querySelector('[data-hgn-kit-bar-switch-input]');
    var switchLabel     = bar.querySelector('[data-hgn-kit-bar-switch-label]');
    var statusBtn       = bar.querySelector('[data-hgn-kit-bar-status]');
    var eyebrowEl       = bar.querySelector('[data-hgn-kit-bar-eyebrow]');
    var metaEl          = bar.querySelector('[data-hgn-kit-bar-meta]');
    var focusEl         = bar.querySelector('[data-hgn-kit-bar-focus]');
    var focusChangeEl   = bar.querySelector('[data-hgn-kit-bar-focus-change]');
    var viewBtn         = bar.querySelector('[data-hgn-kit-bar-view]');
    var canvasEl        = bar.querySelector('[data-hgn-kit-bar-canvas]');
    var ctlToggleEl     = bar.querySelector('[data-hgn-kit-bar-ctl-toggle]');
    var ctlTrackEl      = bar.querySelector('[data-hgn-kit-bar-ctl-track]');

    /* Show / hide the "Change kit" link based on focus state. The
       eyebrow already narrates the tier, so this affordance is just
       the change-kit handle — no duplicate tier label. */
    function renderFocusAffordance() {
      if (!focusEl) return;
      var kp = getKp();
      var focus = (kp && typeof kp.getFocus === 'function') ? kp.getFocus() : null;
      focusEl.hidden = !focus;
    }
    /* Change link — open the focus modal again. The modal's selection
       calls `kp.setFocus()` directly via setKitBuildMode's re-entry,
       but here build mode is already ON so we shortcut: show the modal,
       update focus on resolve. */
    if (focusChangeEl) {
      focusChangeEl.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (!window.HGN || !window.HGN.kitFocusModal ||
            typeof window.HGN.kitFocusModal.show !== 'function') return;
        window.HGN.kitFocusModal.show({ source: 'kit-bar-change' }).then(function (picked) {
          if (picked === '__cancel__') return;
          var kp = getKp();
          if (!kp || typeof kp.setFocus !== 'function') return;
          kp.setFocus(picked === 'any' ? null : picked);
        });
      });
    }
    document.addEventListener('hgn:kit:focus:change', renderFocusAffordance);
    document.addEventListener('hgn:kit-build-mode:change', renderFocusAffordance);

    /* Editor-configurable copy via the announcement section. The
       global is emitted by hgn-announcement.liquid before this
       snippet renders, so it's reliably present here. Each lookup
       falls back to the original hard-coded copy if a setting is
       blank, so a merchant clearing a field can't break the bar. */
    var COPY = (window.HGN_KIT_BAR_COPY || {});
    /* ───── Canonical savings claim (audit 2026-08-12) ─────
       The bar said 40%, the side cart 37%, the how-it-works modal
       25-37% and the drawer computed 38%. All of them now resolve
       through HGN.kitSavingsCeilingPct() in hgn-kit-progress, which
       derives the figure from this market's real kit math; the
       announcement bar's HGN_KIT_SAVINGS_CEILING_PCT is the
       pre-math fallback. SSR copy uses [data-hgn-savings-pct] spans
       (painted by the same module); JS copy uses {savingsPct}. */
    function barSavPct() {
      try {
        if (window.HGN && typeof window.HGN.kitSavingsCeilingPct === 'function') {
          return window.HGN.kitSavingsCeilingPct();
        }
      } catch (e) {}
      var cfg = parseInt(window.HGN_KIT_SAVINGS_CEILING_PCT, 10);
      return (isFinite(cfg) && cfg > 0) ? cfg : 37;
    }
    function barSav(str) {
      if (str == null) return str;
      var v = String(str);
      if (v.indexOf('{savingsPct') === -1) return v;
      try {
        if (window.HGN && typeof window.HGN.fillSavingsTokens === 'function') {
          return window.HGN.fillSavingsTokens(v);
        }
      } catch (e) {}
      return v.replace(/\{savingsPctLow\}/g, String(barSavPct()))
              .replace(/\{savingsPct\}/g, String(barSavPct()));
    }

    function copyOr(key, fallback) {
      var v = COPY[key];
      return (v == null || v === '') ? fallback : v;
    }
    /* Substitute {tier}, {n}, {min}, {remaining}, {s} in any of the
       editor-configurable templates. Kept tiny — no full template
       engine needed; merchants only see this set of placeholders. */
    function fillTokens(tpl, vars) {
      if (!tpl) return '';
      var s = String(tpl);
      Object.keys(vars).forEach(function (k) {
        s = s.split('{' + k + '}').join(vars[k] == null ? '' : vars[k]);
      });
      return s;
    }

    /* Tier metadata lookups — used by the bar's status copy + by the
       help tooltip (which renders tier-specific pricing). */
    var TIER_LABEL = {
      classic:     copyOr('tierLabelClassic', 'Classic Wraps Kit'),
      gels:        copyOr('tierLabelGels', 'Gel Wraps Kit'),
      'press-ons': copyOr('tierLabelPressOn', 'Press-On Kit')
    };
    var TIER_NOUN = {
      classic:     'classic wraps',
      gels:        'gel wraps',
      'press-ons': 'press-on designs'
    };
    var TIER_BY_HANDLE = {
      'non-uv-nail-wraps': 'classic',
      'classic-wraps':     'classic',
      'semi-cured-gels':   'gels',
      'press-on-nails':    'press-ons',
      'press-ons':         'press-ons'
    };
    function detectTier() {
      var path = (window.location.pathname || '').toLowerCase();
      var m = path.match(/\/collections\/([^/?#]+)/);
      return m ? (TIER_BY_HANDLE[m[1]] || null) : null;
    }
    function isCollectionPage() {
      return /\/collections\//.test(window.location.pathname || '');
    }
    function tierMin(tier) {
      var m = (window.HGN && window.HGN.STARTER_KIT_MINIMUMS) ||
        { classic: 5, gels: 3, 'press-ons': 3 };
      return m[tier] || 0;
    }
    function escapeHtml(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    /* ─────── Stage helpers (slot canvas + CTL drawer) ───────
       Ported from hgn-kit-build-toggle's hgn-coll-kit-stage on
       2026-05-12 so the kit-bar is the single canvas surface. The
       per-bar state below (ctlOpen, debounce id) is local to this
       IIFE; caches (ctlCache, productImagesCache) live at module
       scope so a future second mount would share them. */
    var ctlOpen = false;
    var ctlCache = {};        // `<tier>|<sorted handles>` → recs[]
    var ctlInflight = {};     // same key → AbortController
    var ctlDebounceId = 0;
    var productImagesCache = {};
    var productImagesInflight = {};

    /* Decide which tier the bar should render the canvas for. Priority:
         1. Explicit focus from the focus modal (most intentional).
         2. URL-detected tier on collection pages.
         3. Single-tier-with-picks fallback (so a wishlist-side pick
            still surfaces when the shopper navigates off a tier
            collection).
       Returns null when no tier resolves — caller hides the canvas. */
    function resolveStageTier() {
      var kp = getKp();
      if (!kp) return null;
      var focus = (typeof kp.getFocus === 'function') ? kp.getFocus() : null;
      if (focus) return focus;
      var detected = detectTier();
      if (detected) {
        if (typeof kp.isTierEnabled !== 'function' || kp.isTierEnabled(detected)) {
          return detected;
        }
      }
      var s = (typeof kp.read === 'function') ? kp.read() : null;
      if (!s || !s.kits) return null;
      var tiersWithPicks = ['classic', 'gels', 'press-ons'].filter(function (t) {
        if (typeof kp.isTierEnabled === 'function' && !kp.isTierEnabled(t)) return false;
        var k = s.kits[t];
        return k && k.items && k.items.length > 0;
      });
      return tiersWithPicks.length === 1 ? tiersWithPicks[0] : null;
    }

    /* Paint N slots (filled picks → PDP links, empty → hatched `+`). */
    function renderBarCanvas(tier, kit) {
      if (!canvasEl) return;
      var min = tierMin(tier);
      if (!min) { canvasEl.hidden = true; canvasEl.innerHTML = ''; return; }
      var items = (kit && kit.items) ? kit.items : [];
      var html = '';
      for (var i = 0; i < min; i++) {
        var item = items[i];
        if (item) {
          var url = '/products/' + encodeURIComponent(item.handle || '');
          var img = item.image
            ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title || '') + '" loading="lazy">'
            : '';
          html +=
            '<a class="hgn-kit-bar__slot hgn-kit-bar__slot--filled" href="' + escapeHtml(url) + '"' +
              ' data-id="' + escapeHtml(String(item.id || '')) + '"' +
              ' title="' + escapeHtml(item.title || '') + '">' +
              img +
              '<button type="button" class="hgn-kit-bar__slot-remove"' +
                ' data-hgn-kit-bar-slot-remove' +
                ' data-id="' + escapeHtml(String(item.id || '')) + '"' +
                ' aria-label="Remove ' + escapeHtml(item.title || 'pick') + ' from kit"' +
                ' tabindex="-1">' +
                '×' +
              '</button>' +
            '</a>';
        } else {
          html +=
            '<span class="hgn-kit-bar__slot hgn-kit-bar__slot--empty" aria-hidden="true">' +
              '<span class="hgn-kit-bar__slot-plus">+</span>' +
            '</span>';
        }
      }
      canvasEl.innerHTML = html;
    }

    /* CTL fetch — cache keyed by `<tier>|<sorted handles>` so churn
       within the same pick set is free. Re-fetch debounced from
       caller. */
    function ctlKeyFor(tier, handles) {
      return tier + '|' + handles.slice().sort().join(',');
    }
    function fmtMoneyLocal(n) {
      var v = (typeof n === 'number' && isFinite(n)) ? n : 0;
      try {
        if (window.HGN && typeof window.HGN.formatLive === 'function' &&
            typeof window.HGN.activeCurrencyKey === 'function') {
          return window.HGN.formatLive(v, window.HGN.activeCurrencyKey());
        }
      } catch (e) {}
      return '£' + v.toFixed(2);
    }
    function fetchCtlForBar(tier, kit) {
      if (!ctlTrackEl) return;
      var items = (kit && kit.items) || [];
      var handles = items.map(function (it) { return it.handle; }).filter(Boolean);
      var min = tierMin(tier);
      if (handles.length === 0 || (min > 0 && items.length >= min)) {
        ctlTrackEl.innerHTML = '';
        return;
      }
      var key = ctlKeyFor(tier, handles);
      if (ctlCache[key]) { renderCtlTiles(ctlCache[key]); return; }
      if (ctlInflight[key]) return;
      var ctrl = (typeof AbortController === 'function') ? new AbortController() : null;
      ctlInflight[key] = ctrl;
      /* Per-market warehouse SSoT — see hgn-announcement.liquid. */
      var __ctlWh = (typeof window !== 'undefined' && window.HGN_WAREHOUSES) || {};
      fetch('https://holygrailnail.co/api/complete-the-look', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          productHandles: handles,
          tier: tier,
          warehouses: { airbox: __ctlWh.airbox !== false, portless: __ctlWh.portless !== false }
        }),
        credentials: 'omit',
        signal: ctrl ? ctrl.signal : undefined
      })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (data) {
          if (!data || !data.ok || !Array.isArray(data.recommendations)) return;
          var pickedIds = items.map(function (it) { return String(it.id); });
          var pickedHandles = items.map(function (it) { return String(it.handle || ''); });
          var fresh = data.recommendations.filter(function (r) {
            if (pickedHandles.indexOf(String(r.handle || '')) !== -1) return false;
            if (pickedIds.indexOf(String(r.id || '')) !== -1) return false;
            return true;
          });
          ctlCache[key] = fresh;
          renderCtlTiles(fresh);
        })
        .catch(function () { /* abort / hiccup — leave UI alone */ })
        .then(function () { ctlInflight[key] = null; });
    }
    function renderCtlTiles(recs) {
      if (!ctlTrackEl) return;
      if (!recs || recs.length === 0) { ctlTrackEl.innerHTML = ''; return; }
      var trimmed = recs.slice(0, 12);
      var html = trimmed.map(function (r) {
        var thumb = r.image
          ? '<img src="' + escapeHtml(r.image) + '" data-image-index="0" alt="' + escapeHtml(r.title || '') + '" loading="lazy">'
          : '';
        var price = (typeof r.price === 'number')
          ? '<p class="hgn-kit-bar__ctl-tile-price">' + escapeHtml(fmtMoneyLocal(r.price)) + '</p>'
          : '';
        var pdpHref = r.handle ? '/products/' + encodeURIComponent(r.handle) : '#';
        return '<div class="hgn-kit-bar__ctl-tile card-wrapper" data-cycle-handle="' + escapeHtml(r.handle || '') + '" data-cycle-alt="' + escapeHtml(r.title || '') + '">' +
          '<a class="hgn-kit-bar__ctl-tile-link" href="' + escapeHtml(pdpHref) + '" title="' + escapeHtml(r.title || '') + '">' +
            '<span class="hgn-kit-bar__ctl-tile-thumb card__media">' +
              '<span class="media">' + thumb + '</span>' +
            '</span>' +
            '<span class="hgn-kit-bar__ctl-tile-info">' +
              '<p class="hgn-kit-bar__ctl-tile-title">' + escapeHtml(r.title || '') + '</p>' +
              price +
            '</span>' +
          '</a>' +
          '<button type="button" class="hgn-kit-bar__ctl-tile-add"' +
            ' data-hgn-kit-bar-ctl-pick' +
            ' data-id="' + escapeHtml(String(r.id || '')) + '"' +
            ' data-handle="' + escapeHtml(r.handle || '') + '"' +
            ' data-title="' + escapeHtml(r.title || '') + '"' +
            ' data-image="' + escapeHtml(r.image || '') + '"' +
            ' data-price="' + escapeHtml(typeof r.price === 'number' ? String(r.price) : '') + '">' +
            'Add to Starter Kit' +
          '</button>' +
        '</div>';
      }).join('');
      ctlTrackEl.innerHTML = html;
      /* Hand each tile off to mobile-image-cycling.js via a
         /products/<handle>.js fetch + detach/reattach trick that
         tickles the script's MutationObserver. Same approach as the
         kit-stage CTL tiles + Mode B of the kit selector. */
      var tiles = ctlTrackEl.querySelectorAll('.hgn-kit-bar__ctl-tile.card-wrapper');
      trimmed.forEach(function (r, i) {
        var wrapper = tiles[i];
        if (!wrapper || !r.handle) return;
        fetchProductImages(r.handle).then(function (images) {
          attachCyclingImages(wrapper, images);
        });
      });
    }
    function fetchProductImages(handle) {
      if (!handle) return Promise.resolve([]);
      if (productImagesCache[handle]) return Promise.resolve(productImagesCache[handle]);
      if (productImagesInflight[handle]) return productImagesInflight[handle];
      var p = fetch('/products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          var imgs = (data && Array.isArray(data.images)) ? data.images.slice(0, 6) : [];
          productImagesCache[handle] = imgs;
          productImagesInflight[handle] = null;
          return imgs;
        })
        .catch(function () {
          productImagesInflight[handle] = null;
          return [];
        });
      productImagesInflight[handle] = p;
      return p;
    }
    function attachCyclingImages(wrapper, images) {
      if (!wrapper || !images || images.length < 2) return;
      if (wrapper.dataset.cardCyclingInitialized === 'true') return;
      var media = wrapper.querySelector('.card__media .media');
      if (!media) return;
      var existing = media.querySelectorAll('img[data-image-index]');
      if (existing.length >= images.length) return;
      var altBase = wrapper.getAttribute('data-cycle-alt') || '';
      for (var i = existing.length; i < images.length; i++) {
        var img = document.createElement('img');
        img.src = images[i];
        img.setAttribute('data-image-index', String(i));
        img.alt = altBase;
        img.loading = 'lazy';
        media.appendChild(img);
      }
      var parent = wrapper.parentNode;
      if (!parent) return;
      var next = wrapper.nextSibling;
      parent.removeChild(wrapper);
      if (next) parent.insertBefore(wrapper, next);
      else parent.appendChild(wrapper);
    }

    /* Sync compact-mode on the CTL toggle. If the "Suggested" label
       can't fit on the controls row (i.e. the toggle wraps to its own
       line below the canvas), swap the label for a lightbulb icon
       only. Re-runs after every render() and on window resize.

       The trick: temporarily strip `.is-compact` and synchronously
       read the toggle's bounding rect. If it's on a different visual
       row than the canvas, set compact. All measurement + class
       toggling happens inside one JS turn, so the browser only
       paints the final state — no flash. */
    function syncCtlToggleCompactness() {
      if (!ctlToggleEl || !canvasEl) return;
      if (ctlToggleEl.hidden || canvasEl.hidden) {
        ctlToggleEl.classList.remove('is-compact');
        return;
      }
      ctlToggleEl.classList.remove('is-compact');
      var canvasRect = canvasEl.getBoundingClientRect();
      var toggleRect = ctlToggleEl.getBoundingClientRect();
      /* `top` delta > 4px means the toggle wrapped to a new flex line. */
      if ((toggleRect.top - canvasRect.top) > 4) {
        ctlToggleEl.classList.add('is-compact');
      }
    }
    window.addEventListener('resize', syncCtlToggleCompactness);

    /* CTL toggle wiring — flip aria-expanded + drawer visibility,
       fetch on first open. Caches make re-open instant. */
    if (ctlToggleEl && ctlTrackEl) {
      ctlToggleEl.addEventListener('click', function () {
        ctlOpen = !ctlOpen;
        ctlToggleEl.setAttribute('aria-expanded', ctlOpen ? 'true' : 'false');
        ctlTrackEl.hidden = !ctlOpen;
        if (ctlOpen) {
          var kp = getKp();
          var tier = resolveStageTier();
          if (kp && tier && typeof kp.read === 'function') {
            fetchCtlForBar(tier, kp.read().kits[tier] || null);
          }
        }
        publishBarHeight();
      });
    }

    /* Delegated slot-remove clicks — two paths:
         1. Click the × pin → remove. Works on every viewport.
         2. Click anywhere on a filled slot while the canvas is in
            edit mode → remove. The pin becomes a visual cue; the slot
            itself is the tap target. Avoids the "tiny 16px pin on a
            30px mobile slot" tap-target problem.
       Render fires on `hgn:kit:change`, so the slot re-paints as
       empty (or shifts up if a later pick fills its place). */
    if (canvasEl) {
      canvasEl.addEventListener('click', function (e) {
        var editing = canvasEl.classList.contains('is-editing');
        var removeBtn = e.target.closest('[data-hgn-kit-bar-slot-remove]');
        var filledSlot = e.target.closest('.hgn-kit-bar__slot--filled');
        if (!removeBtn && !(editing && filledSlot)) return;
        e.preventDefault();
        e.stopPropagation();
        var kp = getKp();
        var tier = resolveStageTier();
        if (!kp || !tier || typeof kp.removeItem !== 'function') return;
        var idSource = removeBtn || filledSlot;
        var id = String(idSource.getAttribute('data-id') || '');
        if (!id) return;
        kp.removeItem(tier, id);
      });
    }

    /* Edit-mode toggle — flip `.is-editing` on the canvas + the
       button's `aria-pressed`. Reset path lives in render() so the
       mode auto-clears when the canvas hides (no picks / build-off). */
    var canvasEditBtn = bar.querySelector('[data-hgn-kit-bar-canvas-edit]');
    if (canvasEditBtn && canvasEl) {
      canvasEditBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var on = canvasEditBtn.getAttribute('aria-pressed') !== 'true';
        canvasEditBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
        canvasEl.classList.toggle('is-editing', on);
      });
    }

    /* Delegated tile-pick clicks — add to kit (or open swap modal at
       cap). Mirrors the legacy kit-stage handler. */
    if (ctlTrackEl) {
      ctlTrackEl.addEventListener('click', function (e) {
        var pickBtn = e.target.closest('[data-hgn-kit-bar-ctl-pick]');
        if (!pickBtn) return;
        e.preventDefault();
        var kp = getKp();
        var tier = resolveStageTier();
        if (!kp || !tier) return;
        var id = String(pickBtn.getAttribute('data-id') || '');
        var payload = {
          id:     id,
          handle: pickBtn.getAttribute('data-handle') || '',
          title:  pickBtn.getAttribute('data-title') || '',
          image:  pickBtn.getAttribute('data-image') || null,
          price:  parseFloat(pickBtn.getAttribute('data-price')) || null
        };
        if (kp.hasItem && kp.hasItem(tier, id)) return;
        var kit = kp.read().kits[tier] || { items: [] };
        var min = tierMin(tier);
        if (min > 0 && kit.items.length >= min) {
          if (typeof window.HGN.openSwapModal === 'function') {
            window.HGN.openSwapModal(tier, payload);
          }
          return;
        }
        kp.addItem(tier, payload);
      });
    }

    /* ─────── Render: bar visibility + status copy ───────
       Visibility rule: bar shows when (build-mode ON) OR (on a
       /collections/* page). Otherwise hidden. Status copy depends on
       active kit + pick count. */
    function getKp() {
      return (window.HGN && window.HGN.kitProgress) ? window.HGN.kitProgress : null;
    }

    /* Apply / remove a `top` offset on every element that pins to
       the top of the viewport (computed position: sticky | fixed
       AND computed top in [-2px, 2px]) so they sit below the kit-bar
       instead of behind it. Walks the document — themes vary widely
       on which selector wraps the sticky header, so a curated list
       can't be exhaustive. We only process bare sticky-top:0 elements
       so we don't accidentally push down floating buttons / banners
       that happen to be sticky. */
    var managedHeaders = [];
    function applyHeaderOffset() {
      var visible = !bar.hidden;
      var barHeight = visible ? bar.getBoundingClientRect().height : 0;
      /* Restore any previously-managed elements to their original
         `top` first — handles the bar going hidden, height changing,
         or the candidate list shrinking on AJAX re-renders. */
      managedHeaders.forEach(function (entry) {
        if (entry.el && entry.el.style) {
          entry.el.style.top = entry.original || '';
        }
      });
      managedHeaders = [];
      if (!visible || !barHeight) return;
      try {
        var all = document.querySelectorAll('body *');
        for (var i = 0; i < all.length; i++) {
          var el = all[i];
          /* Skip the kit-bar itself, anything inside it, or anything
             inside the side cart (which has its own sticky header). */
          if (el === bar || bar.contains(el)) continue;
          if (el.closest && el.closest('[data-hgn-side-cart]')) continue;
          var cs = getComputedStyle(el);
          if (cs.position !== 'sticky' && cs.position !== 'fixed') continue;
          /* `top` reads as the resolved px value; an unset top is "auto". */
          var topStr = cs.top;
          if (!topStr || topStr === 'auto') continue;
          var topVal = parseFloat(topStr);
          if (isNaN(topVal) || topVal < -2 || topVal > 2) continue;
          managedHeaders.push({ el: el, original: el.style.top || '' });
          el.style.top = barHeight + 'px';
        }
      } catch (e) {}
    }

    function publishBarHeight() {
      try {
        var h = bar.hidden ? 0 : bar.getBoundingClientRect().height;
        document.documentElement.style.setProperty('--hgn-kit-bar-height', h + 'px');
        /* Body class drives the padding-top compensation so the page
           content doesn't slide under the fixed bar. Toggled per
           bar visibility. */
        document.body.classList.toggle('hgn-kit-bar-visible', !bar.hidden);
        applyHeaderOffset();
      } catch (e) {}
    }
    /* Re-apply the offset on window load (sticky-header custom elements
       sometimes upgrade asynchronously) + after a few delayed ticks
       so we catch any late-binding sticky-headers. */
    window.addEventListener('load', applyHeaderOffset);
    setTimeout(applyHeaderOffset, 200);
    setTimeout(applyHeaderOffset, 800);

    /* Many Shopify themes only flip the header to `position: sticky`
       (or fixed) once the shopper scrolls past a threshold — typically
       via a class toggle on a scroll listener. Before that scroll,
       the header is `position: relative` and applyHeaderOffset() ignores
       it (correctly — relatives ride the body padding-top). The moment
       the header transitions to sticky/fixed it snaps to `top: 0` and
       overlaps the kit-bar.

       Catch that transition with an rAF-throttled scroll listener: each
       scroll tick calls applyHeaderOffset, which re-evaluates every
       sticky/fixed candidate against the current barHeight. The work
       is gated by a single rAF so we get one pass per frame at most. */
    var scrollFrame = 0;
    function onScrollReapply() {
      if (scrollFrame) return;
      scrollFrame = requestAnimationFrame(function () {
        scrollFrame = 0;
        applyHeaderOffset();
      });
    }
    window.addEventListener('scroll', onScrollReapply, { passive: true });

    /* Canonical collection URL per tier — same source the
       collection-chrome redirect + side cart use (header emits the
       global). Fallback map mirrors hgn-header.liquid's defaults so
       the bar still routes if the global hasn't loaded. */
    function getCanonicalCollectionUrl(tier) {
      var map = window.HGN_CANONICAL_COLLECTIONS || {
        classic:     '/collections/non-uv-nail-wraps',
        gels:        '/collections/semi-cured-gels',
        'press-ons': '/collections/press-on-nails'
      };
      return (tier && map[tier]) || null;
    }

    /* Where the "Carry on building…" eyebrow navigates on tap. Set by
       render() each pass; null whenever the eyebrow is plain text
       (on-canonical, or no focus tier). The eyebrow click handler
       reads this — when null it does nothing and the click falls
       through to the status button (side cart) as normal. */
    var carryOnTarget = null;
    function applyEyebrow(text, carryUrl) {
      eyebrowEl.textContent = text;
      carryOnTarget = carryUrl || null;
      eyebrowEl.classList.toggle('hgn-kit-bar__eyebrow--carry-on', !!carryUrl);
    }

    function render() {
      /* Always re-evaluate the focus affordance — it's independent
         of build-mode + picks state. */
      renderFocusAffordance();
      var kp = getKp();
      var buildMode = kp && typeof kp.getKitBuildMode === 'function'
        ? kp.getKitBuildMode() : 'off';
      var state = kp ? kp.read() : null;
      /* Prefer focus over activeKit when picking which tier the bar
         narrates. If the shopper has committed to a tier via the focus
         modal, that's the authoritative target — even if activeKit
         still points at a previously-built kit whose memory survived
         a toggle-OFF migration. Without this, a re-toggle ON with a
         different focus would show the OLD tier in the eyebrow.
         Fall back to activeKit only when focus is null (undecided). */
      var focusTier = (kp && typeof kp.getFocus === 'function') ? kp.getFocus() : null;
      var active = focusTier || (state && state.activeKit);
      /* Defensive: getActiveKit already nulls out a disabled tier, but
         a raw read of state.activeKit can still surface one. */
      if (active && kp && typeof kp.isTierEnabled === 'function' && !kp.isTierEnabled(active)) {
        active = null;
      }
      var picks = active && state.kits[active] ? state.kits[active].items.length : 0;
      var minimum = tierMin(active);
      var label = TIER_LABEL[active] || 'Starter Kit';
      /* Off-canonical = build mode is ON, a focus tier is resolved, we
         know its collection URL, and the shopper isn't currently on
         that collection (different tier collection, /collections/all,
         a PDP, the homepage — anything that isn't the kit's own
         collection). In that state the eyebrow turns into a "Carry on
         building your …" link back to the collection, closing the
         navigation gap.

         On-canonical is true when EITHER `detectTier()` folds the
         current handle down to this tier (covers the known alias
         handles in TIER_BY_HANDLE) OR the current handle literally
         matches the canonical URL's handle (covers a merchant-set
         custom canonical that isn't in TIER_BY_HANDLE — otherwise
         we'd dangle a "carry on" link pointing at the page the
         shopper is already on). */
      var carryOnUrl = getCanonicalCollectionUrl(active);
      var offCanonical = false;
      if (active && carryOnUrl) {
        var canonHandle = (String(carryOnUrl).toLowerCase()
          .match(/\/collections\/([^/?#]+)/) || [])[1];
        var hereHandle = (String(window.location.pathname || '').toLowerCase()
          .match(/\/collections\/([^/?#]+)/) || [])[1];
        var onCanonical = (detectTier() === active) ||
          (!!canonHandle && hereHandle === canonHandle);
        offCanonical = !onCanonical;
      }

      /* Visibility (#47): bar only renders once the shopper has
         explicitly opted into kit-build mode. The collection-chrome
         hero strip (`hgn-coll-kit-toggle-wrap`) is the discovery
         surface that flips the switch ON; once flipped, this bar
         appears as the persistent status banner. Stays visible on
         non-collection pages too (so picks aren't stranded after a
         shopper navigates away mid-build), and disappears the
         moment the shopper switches off. */
      var shouldShow = (buildMode === 'on');
      if (!shouldShow) {
        bar.hidden = true;
        publishBarHeight();
        return;
      }
      bar.hidden = false;

      /* Switch reflects current build-mode. */
      if (switchInput) switchInput.checked = (buildMode === 'on');
      if (switchLabel) switchLabel.textContent = (buildMode === 'on')
        ? copyOr('switchOn', 'Building')
        : copyOr('switchOff', 'Build a Kit');
      if (viewBtn) {
        var viewSpan = viewBtn.querySelector('span');
        if (viewSpan) viewSpan.textContent = copyOr('viewLabel', 'View kit');
      }

      /* Status copy — all strings come from the merchant-configurable
         copy global, with the original hard-coded copy as fallback.
         `eyebrow` is plain text (sentence case display headline);
         `meta` may include <strong> tags so the editor can tint key
         phrases terracotta — innerHTML, with HTML-allowed copy
         coming exclusively from theme-editor settings (trusted). */
      if (buildMode !== 'on') {
        applyEyebrow(copyOr('idleEyebrow', 'Build a Starter Kit'), null);
        if (metaEl) {
          metaEl.hidden = false;
          /* Canonical savings (audit 2026-08-12): the fallback carries a
             {savingsPct} token that barSav() resolves from the real
             per-market kit math. A merchant-set literal still wins. */
          metaEl.innerHTML = barSav(copyOr('idleMeta', 'Pick designs &amp; <strong>save up to {savingsPct}%</strong>'));
        }
        if (viewBtn) viewBtn.hidden = true;
        bar.classList.remove('hgn-kit-bar--has-canvas');
        publishBarHeight();
        return;
      }

      /* Build-mode ON — copy progresses with pick state. */
      if (!active || picks === 0) {
        if (offCanonical) {
          /* Focus tier chosen but the shopper has wandered off its
             collection — point them back rather than narrate empty. */
          applyEyebrow(
            fillTokens(copyOr('carryOnEyebrow', 'Carry on building your {tier}'), { tier: label }),
            carryOnUrl
          );
        } else if (active) {
          /* Focus tier chosen, on its collection, no picks yet — name
             the kit so the eyebrow isn't generically "Build a kit". */
          applyEyebrow(
            fillTokens(copyOr('buildEmptyFocusedEyebrow', 'Building your {tier}'), { tier: label }),
            null
          );
        } else {
          /* No focus tier at all (undecided) — generic recruitment. */
          applyEyebrow(copyOr('buildEmptyEyebrow', 'Build your Starter Kit'), null);
        }
        if (metaEl) {
          metaEl.hidden = false;
          metaEl.innerHTML = copyOr('buildEmptyMeta', 'Tap <strong>Add to Starter Kit</strong> on any design to get going');
        }
        if (viewBtn) viewBtn.hidden = true;
        if (ctlToggleEl) ctlToggleEl.hidden = true;
        if (canvasEl) {
          canvasEl.hidden = true;
          canvasEl.innerHTML = '';
          canvasEl.classList.remove('is-editing');
        }
        if (canvasEditBtn) {
          canvasEditBtn.hidden = true;
          canvasEditBtn.setAttribute('aria-pressed', 'false');
        }
        if (ctlTrackEl) ctlTrackEl.hidden = true;
      } else {
        var ready = picks >= minimum;
        /* With picks present + a tier resolved the slot canvas is the
           progress voice — meta line goes silent so we don't double-
           narrate "3/5" once with copy AND once with tiles. Eyebrow
           stays merchant-configurable (no {n}/{min} tokens left). */
        if (offCanonical) {
          /* Mid-build but off the kit's collection — route back. The
             slot canvas still carries the progress count, so the
             eyebrow is free to be the "get me back there" handle. */
          applyEyebrow(
            fillTokens(copyOr('carryOnEyebrow', 'Carry on building your {tier}'), { tier: label }),
            carryOnUrl
          );
        } else if (ready) {
          applyEyebrow(fillTokens(copyOr('readyEyebrow', 'Your {tier} is ready'), {
            tier: label, n: picks, min: minimum, remaining: 0, s: ''
          }), null);
        } else {
          applyEyebrow(fillTokens(copyOr('buildingEyebrow', 'Building your {tier}'), {
            tier: label, n: picks, min: minimum
          }), null);
        }
        if (metaEl) { metaEl.hidden = true; metaEl.innerHTML = ''; }

        /* Canvas — paint when a tier resolves AND min > 0. Edit
           toggle rides alongside; the @media (hover: hover) display
           rule in CSS handles desktop visibility (hidden), so we
           always unset `hidden` here when the canvas is up. */
        if (canvasEl && minimum > 0) {
          canvasEl.hidden = false;
          renderBarCanvas(active, state.kits[active]);
          if (canvasEditBtn) canvasEditBtn.hidden = false;
        } else if (canvasEl) {
          canvasEl.hidden = true;
          canvasEl.innerHTML = '';
          canvasEl.classList.remove('is-editing');
          if (canvasEditBtn) {
            canvasEditBtn.hidden = true;
            canvasEditBtn.setAttribute('aria-pressed', 'false');
          }
        }

        /* Right-edge cluster — building shows the CTL toggle, ready
           swaps to View kit. CTL drawer collapses on ready (next step
           is conversion, not more picks). */
        if (ready) {
          if (viewBtn) viewBtn.hidden = false;
          if (ctlToggleEl) ctlToggleEl.hidden = true;
          if (ctlTrackEl) { ctlTrackEl.hidden = true; ctlTrackEl.innerHTML = ''; }
          ctlOpen = false;
        } else {
          if (viewBtn) viewBtn.hidden = true;
          if (ctlToggleEl) {
            ctlToggleEl.hidden = false;
            ctlToggleEl.setAttribute('aria-expanded', ctlOpen ? 'true' : 'false');
          }
          if (ctlTrackEl) ctlTrackEl.hidden = !ctlOpen;
          /* Debounced re-fetch — only when the drawer is open. The
             cache key bakes in the handle set so unchanged picks don't
             re-hit the worker. */
          if (ctlOpen) {
            if (ctlDebounceId) clearTimeout(ctlDebounceId);
            ctlDebounceId = setTimeout(function () {
              ctlDebounceId = 0;
              fetchCtlForBar(active, state.kits[active]);
            }, 300);
          }
        }
      }
      /* Flag canvas presence so the mobile CSS knows whether to keep
         the status block as a stacked column (no canvas → eyebrow /
         focus / meta each get their own line) or collapse it back to
         a single row (canvas up → it's the progress voice). */
      if (canvasEl) bar.classList.toggle('hgn-kit-bar--has-canvas', !canvasEl.hidden);
      publishBarHeight();
      /* Decide whether "Suggested" fits or we need the lightbulb fallback.
         Has to run AFTER publishBarHeight() since that's what unsets the
         bar's `hidden` attribute / triggers the final flex layout. */
      syncCtlToggleCompactness();
    }

    /* ─────── Focus modal (toggle ON) ───────
       Replaces the legacy on-confirm modal. Public API is exposed
       on `window.HGN.kitFocusModal.show(opts)` so other surfaces
       (kit-bar's "Change" affordance, future deep links) can re-open
       it. Resolves with the picked tier ('classic'|'gels'|'press-ons'),
       'any' for "haven't decided", or '__cancel__' for scrim/Esc/X.

       `setKitBuildMode('on')` itself calls `show()` when no focus
       was supplied — so the kit-bar switch handler doesn't need to
       know about this modal at all; toggling the switch ON is
       enough to trigger it. */
    var focusModal     = document.querySelector('[data-hgn-kit-focus-modal]');
    var focusOptionsEl = focusModal ? focusModal.querySelector('[data-hgn-kit-focus-options]') : null;
    var focusActiveResolver = null;
    function closeFocusModal(picked) {
      if (!focusModal) return;
      focusModal.hidden = true;
      if (focusActiveResolver) {
        var resolve = focusActiveResolver;
        focusActiveResolver = null;
        resolve(picked || '__cancel__');
      }
    }

    /* Compute per-tier ranking + counts. Score = items currently in
       cart with that tier's product_type + items in kit memory.
       Returns `{ classic: { cartCount, picksCount, score }, gels: ..., 'press-ons': ... }`. */
    function buildFocusCounts() {
      var kp = getKp();
      var counts = {
        classic:     { cartCount: 0, picksCount: 0, score: 0 },
        gels:        { cartCount: 0, picksCount: 0, score: 0 },
        'press-ons': { cartCount: 0, picksCount: 0, score: 0 }
      };
      if (kp) {
        var tiers = ['classic', 'gels', 'press-ons'];
        tiers.forEach(function (t) {
          var k = kp.getKit ? kp.getKit(t) : null;
          var len = (k && Array.isArray(k.items)) ? k.items.length : 0;
          counts[t].picksCount = len;
          counts[t].score += len;
        });
      }
      return counts; // cartCount filled in async by the caller
    }

    /* Async fetch of cart-side counts via tierFromProductType. */
    function fillFocusCartCounts(counts) {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart || !Array.isArray(cart.items) ||
              !window.HGN || typeof window.HGN.tierFromProductType !== 'function') return counts;
          cart.items.forEach(function (it) {
            /* Skip lines already inside a bundle — they're not "loose"
               cart items the shopper picked; treating them as
               eligible would inflate the count. */
            var p = it.properties || {};
            if (p['_bundle_id'] || p._bundle_id) return;
            /* Skip lines that can never become a kit pick (packs,
               "Matching Tips & Toes" sets, accessories) — counting
               them would promise picks the shopper can't make. */
            var kpE = window.HGN && window.HGN.kitProgress;
            if (kpE && typeof kpE.isCartLineKitEligible === 'function' &&
                !kpE.isCartLineKitEligible(it)) return;
            var tier = window.HGN.tierFromProductType(it.product_type);
            if (!tier || !counts[tier]) return;
            counts[tier].cartCount += (it.quantity || 1);
            counts[tier].score    += (it.quantity || 1);
          });
          return counts;
        })
        .catch(function () { return counts; });
    }

    function renderFocusOptions(counts) {
      if (!focusOptionsEl) return;
      /* Hide rows for tiers the merchant has disabled in announcement-
         bar settings. Done at render time (not at modal-mount) so a
         late-loading HGN_KIT_ENABLED still takes effect. The rows
         carry data-hgn-kit-focus-row="<tier>" so we can address them
         without ripping them out of the DOM. */
      var enabled = (window.HGN && window.HGN.kitProgress &&
        typeof window.HGN.kitProgress.isTierEnabled === 'function')
        ? window.HGN.kitProgress.isTierEnabled
        : function () { return true; };
      focusOptionsEl.querySelectorAll('[data-hgn-kit-focus-row]').forEach(function (li) {
        var rowTier = li.getAttribute('data-hgn-kit-focus-row');
        if (rowTier === 'any') return;
        li.hidden = !enabled(rowTier);
      });
      var rows = focusOptionsEl.querySelectorAll('[data-hgn-kit-focus-pick]');
      /* First find the top-ranked tier so we can highlight it. Ties
         break by tier order: classic > gels > press-ons. Score 0
         (no signal at all) → no recommendation. Disabled tiers
         skipped entirely. */
      var winner = null;
      var winnerScore = 0;
      ['classic', 'gels', 'press-ons'].forEach(function (t) {
        if (!enabled(t)) return;
        var s = counts[t].score;
        if (s > winnerScore) { winnerScore = s; winner = t; }
      });
      /* Per-tier "Choose N designs..." pitch copy. The minimum is
         pulled from the live HGN.STARTER_KIT_MINIMUMS global so
         per-market overrides surface in the modal automatically. */
      var minimums = (window.HGN && window.HGN.STARTER_KIT_MINIMUMS) ||
        { classic: 5, gels: 3, 'press-ons': 3 };
      rows.forEach(function (btn) {
        var tier = btn.getAttribute('data-hgn-kit-focus-pick');
        var sub = btn.querySelector('[data-hgn-kit-focus-sub]');
        var pitch = btn.querySelector('[data-hgn-kit-focus-pitch]');
        var hint = btn.querySelector('[data-hgn-kit-focus-hint]');
        if (tier === 'any') return;
        if (pitch) {
          var n = minimums[tier] || 0;
          pitch.textContent = n > 0
            ? ('Choose ' + n + ' design' + (n === 1 ? '' : 's') + ', pick your accessories and save up to ' + barSavPct() + '%.')
            : '';
        }
        var info = counts[tier] || { cartCount: 0, picksCount: 0 };
        var parts = [];
        if (info.cartCount > 0) {
          parts.push(info.cartCount + ' in cart');
        }
        if (info.picksCount > 0) {
          parts.push(info.picksCount + ' picked');
        }
        if (sub) {
          sub.textContent = parts.length
            ? parts.join(' \u00b7 ')
            : '';
        }
        if (hint) {
          if (winner === tier) {
            hint.hidden = false;
            btn.classList.add('is-recommended');
          } else {
            hint.hidden = true;
            btn.classList.remove('is-recommended');
          }
        }
      });
    }

    if (focusModal && focusOptionsEl) {
      focusModal.addEventListener('click', function (e) {
        if (e.target.closest('[data-hgn-kit-focus-cancel]')) {
          closeFocusModal('__cancel__');
          return;
        }
        var pickBtn = e.target.closest('[data-hgn-kit-focus-pick]');
        if (pickBtn) {
          closeFocusModal(pickBtn.getAttribute('data-hgn-kit-focus-pick'));
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !focusModal.hidden) closeFocusModal('__cancel__');
      });
    }

    /* Public API: window.HGN.kitFocusModal.show() → Promise. */
    window.HGN = window.HGN || {};
    window.HGN.kitFocusModal = {
      show: function (opts) {
        if (!focusModal) return Promise.resolve('any'); // no modal mounted → fall through to legacy
        /* If a previous show() is still open, resolve it with cancel
           and replace with the new one. */
        if (focusActiveResolver) {
          var prev = focusActiveResolver;
          focusActiveResolver = null;
          prev('__cancel__');
        }
        var counts = buildFocusCounts();
        renderFocusOptions(counts);
        focusModal.hidden = false;
        /* Cart-count fetch is async; re-render once it lands. */
        fillFocusCartCounts(counts).then(renderFocusOptions);
        return new Promise(function (resolve) { focusActiveResolver = resolve; });
      },
      close: function () { closeFocusModal('__cancel__'); }
    };

    /* Hook into setKitBuildMode's cancellation: when the focus modal
       is dismissed via scrim/Esc/X, the toggle should bounce back. */
    document.addEventListener('hgn:kit-build-mode:change', function (e) {
      if (!switchInput) return;
      var mode = e && e.detail && e.detail.to;
      if (mode === 'on' || mode === 'off') {
        switchInput.checked = (mode === 'on');
      }
    });

    /* ─────── Switch flip handler ─────── */
    function handleSwitchChange() {
      if (!switchInput) return;
      var kp = getKp();
      if (!kp || typeof kp.setKitBuildMode !== 'function') return;

      if (switchInput.checked) {
        /* OFF → ON. setKitBuildMode opens the focus modal itself
           when no `focus` opt is supplied, then runs migration
           filtered to the chosen tier. If the shopper cancels the
           modal, the resulting `cancelled: true` flag bounces the
           switch back via the change-event listener wired below. */
        kp.setKitBuildMode('on', { source: 'kit-bar' }).then(function (res) {
          if (res && res.cancelled && switchInput) {
            switchInput.checked = false;
          }
        });
      } else {
        /* ON → OFF. If picks exist, open OFF-confirm modal.
           Otherwise flip directly. */
        var picks = (typeof kp.totalKitPicks === 'function') ? kp.totalKitPicks() : 0;
        if (picks === 0) {
          kp.setKitBuildMode('off', { source: 'kit-bar-no-picks' });
          return;
        }
        openKitOffModal({ source: 'kit-bar', cancelSource: 'kit-bar' });
      }
    }
    if (switchInput) switchInput.addEventListener('change', handleSwitchChange);

    /* If the OFF-confirm modal is cancelled, re-check the switch input. */
    document.addEventListener('hgn:kit-off:cancelled', function () {
      if (switchInput) switchInput.checked = true;
    });

    /* ─────── Status / View tap → open side cart at build section ───────
       Use the side-cart API directly (no event dispatch) so the open
       can't be misinterpreted by other surfaces (Spotlight facets was
       reacting to the legacy `cart:open` event in some cases). The
       scroll-to-build event is fine as a custom event since only the
       side-cart kit controller listens for it. */
    function openSideCartAtBuild(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      if (window.HGN && window.HGN.sideCart && typeof window.HGN.sideCart.open === 'function') {
        window.HGN.sideCart.open();
      } else {
        /* Fallback for very early clicks before the side cart's IIFE
           has booted — defer dispatch + retry once. */
        setTimeout(function () {
          if (window.HGN && window.HGN.sideCart) window.HGN.sideCart.open();
        }, 80);
      }
      try {
        document.dispatchEvent(new CustomEvent('hgn:side-cart:scroll-to-build'));
      } catch (err) {}
    }
    if (statusBtn) statusBtn.addEventListener('click', openSideCartAtBuild);
    if (viewBtn) viewBtn.addEventListener('click', openSideCartAtBuild);

    /* Off-canonical eyebrow → route back to the focus kit's collection.
       Only fires when render() has set `carryOnTarget` (i.e. the
       eyebrow is in its "Carry on building…" state); otherwise the
       click bubbles to the status button and opens the side cart as
       before. This is purely an added navigation shortcut — no other
       status-button behaviour changes. */
    if (eyebrowEl) {
      eyebrowEl.addEventListener('click', function (e) {
        if (!carryOnTarget) return;
        e.preventDefault();
        e.stopPropagation();
        window.location.href = carryOnTarget;
      });
    }


    /* ─────── OFF-confirm modal ─────── */
    var offModal      = document.querySelector('[data-hgn-kit-off-modal]');
    var offConfirm    = offModal ? offModal.querySelector('[data-hgn-kit-off-confirm]') : null;
    var offConfirmLbl = offModal ? offModal.querySelector('[data-hgn-kit-off-confirm-label]') : null;
    function openKitOffModal(opts) {
      if (!offModal) return;
      var kp = getKp();
      var picks = (kp && typeof kp.totalKitPicks === 'function') ? kp.totalKitPicks() : 0;
      if (picks === 0) {
        if (kp) kp.setKitBuildMode('off', { source: (opts && opts.source) || 'no-picks-direct' });
        return;
      }
      if (offConfirmLbl) offConfirmLbl.textContent = 'Keep Items, Lose Discount?';
      if (offConfirm) offConfirm.disabled = false;
      offModal.hidden = false;
    }
    function closeKitOffModal(opts) {
      if (!offModal) return;
      offModal.hidden = true;
      if (opts && opts.cancelled) {
        try {
          document.dispatchEvent(new CustomEvent('hgn:kit-off:cancelled'));
        } catch (e) {}
      }
    }
    if (offModal) {
      offModal.addEventListener('click', function (e) {
        if (e.target.closest('[data-hgn-kit-off-cancel]')) {
          closeKitOffModal({ cancelled: true });
        }
      });
      if (offConfirm) {
        var offError = offModal.querySelector('[data-hgn-kit-off-error]');
        var offConfirmDefaultLbl = offConfirmLbl ? offConfirmLbl.textContent : '';
        offConfirm.addEventListener('click', function () {
          if (offConfirm.disabled) return;
          var kp = getKp();
          if (!kp) return;
          offConfirm.disabled = true;
          if (offError) offError.hidden = true;
          if (offConfirmLbl) offConfirmLbl.textContent = 'Moving to cart\u2026';
          kp.setKitBuildMode('off', { source: 'off-confirm-modal' })
            .then(function (result) {
              /* Since the B3 fix, kit-progress refuses the OFF flip when
                 the kit\u2192cart migration totally fails (result.ok:false,
                 mode stays on, picks intact). Keep the modal OPEN with
                 an inline error + re-armed button so the shopper can
                 retry \u2014 closing it while silently console-warning left
                 them staring at a bar that ignored their click. */
              var failed = (result && result.ok === false) ||
                           (result && result.migration && result.migration.ok === false);
              if (failed) {
                offConfirm.disabled = false;
                if (offConfirmLbl) offConfirmLbl.textContent = offConfirmDefaultLbl || 'Try again';
                if (offError) offError.hidden = false;
                return;
              }
              closeKitOffModal({ cancelled: false });
              try {
                document.dispatchEvent(new CustomEvent('hgn:cart:open'));
              } catch (e) {}
            })
            .catch(function () {
              /* Unexpected rejection \u2014 same recovery as a failed move. */
              offConfirm.disabled = false;
              if (offConfirmLbl) offConfirmLbl.textContent = offConfirmDefaultLbl || 'Try again';
              if (offError) offError.hidden = false;
            });
        });
      }
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && offModal && !offModal.hidden) closeKitOffModal({ cancelled: true });
      });
    }
    window.HGN = window.HGN || {};
    window.HGN.openKitOffModal = openKitOffModal;

    /* ─────── Swap modal — kept logic from v1 ─────── */
    var swapRoot       = document.querySelector('[data-hgn-kit-swap]');
    var swapList       = swapRoot ? swapRoot.querySelector('[data-hgn-kit-swap-list]') : null;
    var swapHint       = swapRoot ? swapRoot.querySelector('[data-hgn-kit-swap-hint]') : null;
    var pendingSwap    = null;

    function openSwapModal(tier, newItem) {
      if (!swapRoot || !swapList) return;
      var kp = getKp();
      if (!kp) return;
      var kit = kp.getKit(tier);
      if (!kit || !kit.items.length) return;
      /* Theme-editor opt-out: 'cart-passthrough' replaces the swap
         modal with a side-cart nudge to finish the kit. The new item
         is intentionally NOT added to the kit (it's at cap) — the
         caller's takeover should already be off in this mode, so the
         shopper's original ATC click goes through to cart. This path
         only fires from legacy / non-takeover surfaces. */
      try {
        if (window.HGN_KIT_FULL_BEHAVIOUR === 'cart-passthrough') {
          if (window.HGN && window.HGN.sideCart && typeof window.HGN.sideCart.open === 'function') {
            window.HGN.sideCart.open();
          }
          setTimeout(function () {
            try {
              document.dispatchEvent(new CustomEvent('hgn:side-cart:scroll-to-build'));
            } catch (e) {}
          }, 80);
          return;
        }
      } catch (e) {}
      pendingSwap = { tier: tier, newItem: newItem };
      var html = '';
      kit.items.forEach(function (it) {
        html += '<button type="button" class="hgn-kit-swap__row" data-hgn-kit-swap-row data-id="' + escapeHtml(it.id) + '">';
        if (it.image) {
          html += '<img src="' + escapeHtml(it.image) + '" alt="" loading="lazy">';
        } else {
          html += '<span style="width:56px;height:56px;background:var(--hgn-warm);flex-shrink:0;"></span>';
        }
        html += '<p class="hgn-kit-swap__row-title">' + escapeHtml(it.title || '') + '</p>';
        html += '</button>';
      });
      swapList.innerHTML = html;
      if (swapHint && newItem && newItem.title) {
        swapHint.textContent = 'Tap a pick below to replace it with ' + newItem.title + '.';
      } else if (swapHint) {
        swapHint.textContent = 'Tap a pick below to replace it with your new choice.';
      }
      swapRoot.hidden = false;
    }
    function closeSwapModal() {
      if (!swapRoot) return;
      swapRoot.hidden = true;
      pendingSwap = null;
    }
    if (swapRoot) {
      swapRoot.addEventListener('click', function (e) {
        if (e.target.closest('[data-hgn-kit-swap-cancel]')) { closeSwapModal(); return; }
        var row = e.target.closest('[data-hgn-kit-swap-row]');
        if (!row || !pendingSwap) return;
        var oldId = row.getAttribute('data-id');
        if (!oldId) return;
        var kp = getKp();
        if (!kp) return;
        kp.removeItem(pendingSwap.tier, oldId);
        kp.addItem(pendingSwap.tier, pendingSwap.newItem);
        closeSwapModal();
      });
    }
    window.HGN.openSwapModal = openSwapModal;

    /* ─────── Subscriptions + init ─────── */
    document.addEventListener('hgn:kit:change', render);
    document.addEventListener('hgn:kit-build-mode:change', render);
    /* Currency-aware re-render: any {savings} / {bundle} token in the
       editor-configurable copy is GBP-anchored but displayed via
       formatLive; re-render when the visitor switches currency or
       when live FX rates load so the displayed amount stays correct. */
    document.addEventListener('shopify:currency:update', render);
    document.addEventListener('hgn:fx:update', render);
    window.addEventListener('resize', publishBarHeight);

    /* UTM auto-flip — preserved from collection-chrome v1. */
    (function autoFlipFromUTM() {
      try {
        var qs = new URLSearchParams(window.location.search || '');
        var wantOn =
          (qs.get('kit') || '').toLowerCase() === 'on' ||
          (qs.get('utm_content') || '').toLowerCase() === 'hgn_kit_on' ||
          (qs.get('utm_campaign') || '').toLowerCase() === 'hgn_kit_on';
        if (!wantOn) return;
        var kp = getKp();
        if (!kp || kp.getKitBuildMode() === 'on') return;
        if (switchInput) switchInput.checked = true;
        handleSwitchChange();
      } catch (e) {}
    })();

    render();
    /* Side-cart kit IIFE exposes `window.HGN.computeKitMath` from a
       sibling ready() handler that runs AFTER this one in the same
       DOMContentLoaded tick. Re-render once the helper is available
       so any {savings} / {bundle} tokens in the editor-configurable
       copy resolve correctly on first paint (without waiting for the
       first kit-change event). */
    setTimeout(render, 100);
  });
})();
